var _path, _path2, _path3, _path4, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigestibleResults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 18.5L22 39.5C22 40.6046 22.8954 41.5 24 41.5L48.7222 41.5L57 41.5C58.1046 41.5 59 40.6046 59 39.5L59 18.5C59 17.3954 58.1046 16.5 57 16.5L24 16.5C22.8954 16.5 22 17.3954 22 18.5Z",
    fill: "#D1EAFC",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 85.5L50 104.5C50 105.605 50.8954 106.5 52 106.5L84.6667 106.5L96 106.5C97.1046 106.5 98 105.605 98 104.5L98 85.5C98 84.3954 97.1046 83.5 96 83.5L52 83.5C50.8954 83.5 50 84.3954 50 85.5Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 85.5L22 104.5C22 105.605 22.8954 106.5 24 106.5L35 106.5L38 106.5C39.1046 106.5 40 105.605 40 104.5L40 85.5C40 84.3954 39.1046 83.5 38 83.5L24 83.5C22.8954 83.5 22 84.3954 22 85.5Z",
    fill: "#A3C5FF",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 55.5L22 69.5C22 70.6046 22.8954 71.5 24 71.5L76.8889 71.5L96 71.5C97.1046 71.5 98 70.6046 98 69.5L98 55.5C98 54.3954 97.1046 53.5 96 53.5L24 53.5C22.8954 53.5 22 54.3954 22 55.5Z",
    fill: "#D1EAFC",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 83.5,
    cy: 29,
    r: 12.5,
    fill: "white",
    stroke: "#333333",
    strokeWidth: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigestibleResults);
export default __webpack_public_path__ + "static/media/digestible-results.6f94eb41.svg";
export { ForwardRef as ReactComponent };